<template>
  <div class="my-prize">
    <div class="container">
      <div class="user-id">ID：{{userId}}</div>
      <div class="prize-box">
        <div class="item" :class="item.win_goods_type == 10 ? 'big-item' : 'small-item'" v-for="(item,index) in prizeList" :key="index">
          <img :src="item.win_goods_pic" alt="" class="img">
          <div class="center">
            <span class="text">串码ID：{{ item.code_id }}</span>
            <span class="text">中奖时间：{{ item.scan_time }}</span>
            <span class="tips" v-if="item.win_goods_type == 10 && (item.grant_status == 111 || item.grant_status == 10)">请及时填写领奖信息，工作人员将尽快联系您核实信息及奖品派发事宜。</span>
            <span class="tips" v-if="item.win_goods_type == 10 && (item.grant_status == 21)">您已提交领奖信息，工作人员将尽快联系您核实信息及奖品派发事宜。</span>
            <button v-if="item.showBtn" @click="clickBtn(index)">{{item.btnTxt}}</button>
          </div>
          <div class="status" :class="item.win_goods_type == 10 ? 'big-status' : 'small-status'" >
            <span>{{ item.statusTxt }}</span>
          </div>
        </div>
        <!-- 空状态 -->
        <div class="empty" v-if="isEmpty">
          <img src="https://cdn.geement.com/sfiles/BaiShiKeLe/JiLinBaiShi/JiLinBaiShi_acth5_2025_06/prize_no_list.png" alt="" srcset="">
          <span>暂时还没有您的数据，</span>
          <span>快去扫码得红包吧~</span>
        </div>
      </div>
      <button @click="goBackFn">返回首页</button>
      
      <!-- loading -->
      <Loading v-if="isLoading" />
    </div>
  </div>
</template>

<script>
  import { getWinGoods } from '../../../static/js/common.js'
  import Loading from '../../components/loading/loading.vue'
  import AreaPicker from "../../components/form/address/AreaPicker.vue";
  export default {
      components: {
        Loading,
        AreaPicker
      },
      data() {
        return {
          actcodes: localStorage.getItem('act'),
          userId: '', // 用户ID
          prizeList: [], //奖品列表
          receive_etime: '', // 领奖截止时间
          isEmpty: false, // 是否展示空状态

          isPrizeShow: false, // 是否展示中奖弹窗
          winGoodsInfo: {
            prizedto: {}
          }, // 中奖信息

          formData: {
              receive_phone: "",//收件人手机号
              receive_name: "",//收件人姓名
              receive_provice_id: "",//
              receive_city_id: "",//
              receive_area_id: "",//
              receive_address: "",//详细地址
              areaValue: {
                  provice_id: '',
                  city_id: '',
                  area_id: '',
                  provice_name: '',
                  city_name: '',
                  area_name: ''
              }
          },

          isPrizeDetailShow: false,// 是否展示中奖详情弹窗
          prizeDetailInfo: {}, // 中奖详情信息
        }
      },
      created() {
        this.getUserInfo()
        let timer = setInterval(() => {
          if (!this.$store.state.init_loading) return

          clearInterval(timer)
    
          this.$nextTick(() => {
            this.init();
          });
        }, 10)
      },
      methods: {
        // 返回上一页
        goBackFn(){
          this.$router.go(-1);
        },
        // 获取用户信息
        getUserInfo() {
          this.$axios.get(jm.site.usercenterSite + '/api/v1/user/information', {
            params: {
            },
          }).then(res => {
            if (res.success && res.data) {
              this.userId = res.data.user_no
            }
          })
        },

        init() {
          this.receive_etime = jm.getStorageItem('receive_etime')

          this.getPrizeList();
        },

        fifterStatus(item) {
          let obj = {
            statusTxt: "", //状态文字描述
            showBtn: false, //是否显示操作按钮
            btnTxt: "", //按钮上的文字
            receiveType: "", //领奖类型 1-领取实物 2-查看实物 3-领取红包 4-查看优惠券
            glink: "", //跳转链接
          };

          let nowTime = new Date().getTime()
          let receive_etime = new Date(this.receive_etime.replace(/-/g,"/")).getTime()

          switch(item.grant_status) {
            case 5: //裂变奖品，等待好友领取后可领取
              obj.statusTxt = "待发放";
              obj.btnTxt = "查看详情";
              break;
            case 10: //未发放
              obj.statusTxt = "待发放";
              obj.btnTxt = "立即领取";
              obj.grant_status = nowTime >= receive_etime ? -20 : item.grant_status

              if (item.win_goods_type == 10) {
                obj.showBtn = true;
                obj.statusTxt = "待领取";
                obj.receiveType = 1;
              }else if(item.win_goods_type == 50 || item.win_goods_type == 51) {
                obj.showBtn = true;
                obj.statusTxt = "待领取";
                obj.receiveType = 3;
              }
              break;
            case 11: //等待选择奖品领取，裂变奖品中，用户可自行选择一个奖品
              obj.statusTxt = "等待选取";
              obj.btnTxt = "立即选取";
              obj.showBtn = false;
              break;
            case 111: //待提交审核资料
              obj.statusTxt = "待提交审核资料";
              obj.btnTxt = "填写资料";
              obj.showBtn = false;
              break;
            case 12:
              obj.statusTxt = "待审核";
              obj.showBtn = false;
              break;
            case 20://红包、微信支付、流量、话费
              obj.statusTxt = "发放中";
              obj.showBtn = item.win_goods_type == 50 || item.win_goods_type == 51 ? true : false;
              obj.btnTxt = "重新领取";
              obj.receiveType = 3;
              break;
            case 21: //实物已领取(实物奖品)
              obj.statusTxt = item.win_goods_type == 10 ? '待发放' : "已领取";
              obj.showBtn = true;
              obj.btnTxt = "查看详情"
              obj.receiveType = 2;
              break;
            case 30:
              obj.statusTxt = "发放成功";
              if (item.win_goods_type == 10) {
                obj.receiveType = 2
                obj.btnTxt = "查看详情";
                obj.showBtn = true;
              } else if (item.win_goods_type == 40 && item.win_goods_sub_type == 45) {
                obj.receiveType = 4
                obj.btnTxt = "立即领取";
                obj.showBtn = true;
              }
              break;
            case -10://红包，微信支付，流量，话费类型奖品
              obj.statusTxt = "发放失败";
              obj.btnTxt = "重新领取";
              obj.showBtn = true;
              obj.receiveType = 3;
              obj.grant_status = nowTime >= receive_etime ? -20 : item.grant_status
              break;
            case -20://红包、微信支付、流量、话费、资格卡券等奖品
              obj.statusTxt = "已过期";
              obj.showBtn = false;
              break;
            case -30:
              obj.statusTxt = "审核不通过";
              obj.showBtn = false;
              break;
            default:
              break;
          }
          return obj;
        },

        // 查询我的奖品列表
        getPrizeList() {
          this.isLoading = true

          let params = this.actcodes ? {
            act_codes: this.actcodes
          } : null;
          getWinGoods(this, null, params).then(res => {
            this.isLoading = false

            if(res && res.success && res.data && res.data.length) {
              this.isEmpty = false
              this.prizeList = res.data;
              this.prizeList.forEach(t => {
                let obj = this.fifterStatus(t);
                Object.keys(obj).map(k => {
                  t[k] = obj[k]
                })
              });
            } else {
              this.prizeList = []
              this.isEmpty = true
            }

            this.getReceiveCouponList()
          })
        },
        // 监听获取优惠券领取记录
        getReceiveCouponList() {
          this.$axios.get(jm.site.THIRTY + '/api/v1/pepsicola/winlog/receive/log', {
            params: {
              pageNum: 1,
              pageSize: 999
            },
          }).then(res => {
            let list = []
            if (res.success && res.data) {
              list = [...res.data]
            } else {
              list = []
            }

            this.prizeList.forEach(item => {
              if (item.win_goods_type != 40) return

              let findData = list.find(f => f.log_id == item.log_id)
              if (findData) {
                item.showBtn = false
              } else {
                item.showBtn = true
              }
            })

            this.prizeList = [...this.prizeList]
          })
        },

        // 点击按钮
        clickBtn(index) {
          let d = this.prizeList[index];
          console.log(d, '点击按钮');
          switch(d.receiveType) {
            case 1: // 领取实物
              this.isPrizeShow = true;
              this.winGoodsInfo = d;
              break;
            case 2: // 查看实物的领取信息
              this.isPrizeDetailShow = true;
              this.$axios.get(jm.site.ACTJEXTRA + "/api/v1/act/win/goods/detail/" + d.log_id).then(res=>{
                if(res.success && res.data){
                  this.prizeDetailInfo = res.data;
                }
              })
              break;
            case 3: // 重新领取红包
              this.againReceive(d.log_id)
              break;
            case 4: // 查看优惠券
              this.receiveCoupon(d)
              break;
            default:
              break;
          }
        },

        // 监听提交表单
        submitFormFn() {
          console.log(this.formData, 66666);
          if(!this.formData.receive_phone) {
              jm.showMsg('请输入您的手机号码')
              return;
          }
          if(!this.formData.receive_name) {
              jm.showMsg('请输入您的姓名')
              return;
          }
          if(!this.formData.areaValue.provice_id) {
              jm.showMsg('请选择省市区')
              return;
          }
          this.formData.receive_provice_id = this.formData.areaValue.provice_id;
          this.formData.receive_city_id = this.formData.areaValue.city_id;
          this.formData.receive_area_id = this.formData.areaValue.area_id;

          if(!this.formData.receive_address) {
              jm.showMsg('请输入详细地址')
              return;
          }
          this.$axios.post(jm.site.ACTJEXTRA + "/api/v1/act/win/goods/10goods/receive",
            {
              log_id: this.winGoodsInfo.log_id,
                        address: this.formData,
            }
          ).then((res) => {
            if (res.success) {
              this.isPrizeShow = false;
              this.getPrizeList();
            }
          });
        },

        // 重新领取
        againReceive(log_id) {
          if(this.isLoading == true) return;
          this.isLoading = true;
          this.$axios.post(jm.site.ACTJEXTRA + '/api/v1/act/win/goods/5051goods/receive', this.$qs.stringify({
              log_id
          }), {
              headers: {
                  "content-type": "application/x-www-form-urlencoded;charset=UTF-8"
              }
          }).then(data => {
              this.isLoading = false;
              if (data.success) {
                  if(data.data.grant_status == false){
                      if(data.data.cash_server_fail_reason){
                          jm.showMsg(data.data.cash_server_fail_reason)
                      }else{
                          jm.showMsg("领取失败，请稍后再试")
                      }
                  }
                  if(data.data.grant_status == true){
                      if(data.data.cash_grant_type == 2){
                          wx.ready(() => {
                              wx.checkJsApi({
                                  jsApiList: ['requestMerchantTransfer'],
                                  success: function (res) {
                                      if (res.checkResult['requestMerchantTransfer']) {
                                          WeixinJSBridge.invoke('requestMerchantTransfer', {
                                              mchId: data.data.transferorder_bind_mchno,
                                              appId: jm.site.appId,
                                              package: data.data.packageinfo,
                                          },
                                          function (res) {
                                              if (res.err_msg === 'requestMerchantTransfer:ok') {
                                              // res.err_msg将在页面展示成功后返回应用时返回success，并不代表付款成功
                                              }
                                          }
                                          );
                                      } else {
                                          alert('你的微信版本过低，请更新至最新版本。');
                                      }
                                  }
                              });
                          });
                      }else{
                          jm.showMsg('领取成功')
                      }
                  }
              }else{
                  jm.showMsg(data.msg)
              }
          })
        },

        // 监听点击跳转小程序
        handleClickLink() {
          this.isShowError = false
          wx.miniProgram.navigateTo({
            url: '/packages/home/dashboard/index?client_code=CLI4265822080928317440',
            fail: (err) => {
              jm.showMsg('页面不存在')
            }
          })
        },

        // 跳转领取优惠券
        receiveCoupon(data) {
          let url = encodeURIComponent(data.extra_45couponsdto.goods_45_drump_url)
    
          wx.miniProgram.navigateTo({
            url: `/packages/baishiof/hljnavigate/index?appId=${data.extra_45couponsdto.goods_45_drump_appid}&url=${url}`,
            success: () => {
              this.handleReceiveCoupon(data) // 监听记录领取优惠券
            },
            fail: (err) => {
              jm.showMsg('页面不存在')
            }
          })
        },

        // 监听记录领取优惠券
        handleReceiveCoupon(data) {
          this.$axios.post(jm.site.THIRTY + '/api/v1/pepsicola/winlog/receive', {
            log_id: data.log_id
          }).then(res => {
            this.init()
          })
        },
      }
  }
</script>

<style lang="scss" scoped>
.my-prize {
  background: #E60020;
  height: 100% !important;
  &::-webkit-scrollbar {
    display: none;
  }
  .container{
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.85);
    overflow: hidden;
    overflow-y: scroll;
    >button{
      width: 6.95rem;
      height: 1.55rem;
      background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/go_home_btn_bg.png) no-repeat;
      background-size: 100% 100%;
      position: fixed;
      left: 50%;
      bottom: 1rem;
      transform: translateX(-50%);
      font-family: Hiragino Sans GB;
      font-weight: normal;
      font-size: 0.7rem;
      color: #E00221;
    }
  }
  .user-id {
    display: block;
    font-family: PingFang TC;
    font-weight: 600;
    font-size: 0.8rem;
    color: #FFE1B6;
    line-height: 0.8rem;
    padding: 0.6rem 0;
    text-align: center;
  }

  .prize-box {
    padding-bottom: 3rem;
    .item{
      width: 17rem;
      margin: 0 auto 0.25rem;
      display: flex;
      align-items: center;
      >img{
        width: 5.05rem;
        height: 2.8rem;
        margin-left: 0.5rem;
      }
      .center{
        flex: 1;
        height: 100%;
        margin-left: 0.25rem;
        padding: 1.05rem 0 0 0.5rem;
        .text{
          display: block;
          font-family: PingFang TC;
          font-weight: 400;
          font-size: 0.5rem;
          color: #333333;
          line-height: 0.5rem;
          margin-bottom: 0.15rem;
        }
        .tips{
          display: block;
          font-family: PingFang TC;
          font-weight: 500;
          font-size: 0.45rem;
          color: #F93941;
          line-height: 0.6rem;
          margin-bottom: -0.2rem;
          padding-top: 0.8rem;
        }
        >button{
          width: 4.65rem;
          height: 1.2rem;
          background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/back_btn_bg.png) no-repeat;
          background-size: 100% 100%;
          font-family: PingFang TC;
          font-weight: 500;
          font-size: 0.65rem;
          color: #DE0327;
          line-height: 0.65rem;
          margin-left: 1.1rem;
          margin-top: 0.6rem;
        }
      }
      .status{
        width: 1.85rem;
        height: 100%;
        margin-right: 0.85rem;
        display: flex;
        align-items: center;
        justify-content: center;
        span{
          writing-mode: vertical-rl;
          text-orientation: mixed;
          font-family: PingFang TC;
          font-weight: 400;
          font-size: 0.55rem;
          color: #FFFFFF;
        }
      }
      .big-status{
        background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/prize_item_big_status.png) no-repeat;
        background-size: 100% 100%;
      }
      .small-status{
        background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/prize_item_small_status.png) no-repeat;
        background-size: 100% 100%;
      }
    }
    .big-item{
      height: 6.9rem;
      background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/prize_item_big_bg.png) no-repeat;
      background-size: 100% 100%;
    }
    .small-item{
      height: 5rem;
      background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/prize_item_small_bg.png) no-repeat;
      background-size: 100% 100%;
    }
  }

  .empty {
		padding-top: 6rem;
    display: flex;
    flex-direction: column;
    align-items: center;
		img{
      display: block;
      width: 3.9rem;
      height: 3.9rem;
      margin-bottom: 0.85rem;
    }
    span{
      display: block;
      font-family: PingFang SC, PingFang SC;
      font-weight: normal;
      font-size: 0.65rem;
      color: #8EADF5;
      line-height: 1.15rem;
    }
	}

	// ul {
	// 	width: 17.15rem;
	// 	margin: 0 auto;

	// 	li {
	// 		width: 100%;
	// 		border-radius: .4rem;
	// 		padding: .4rem;
	// 		background: #fff;
	// 		box-shadow: 0px 1px 8px 0px rgba(0,0,0,0.06);
	// 		position: relative;
	// 		margin-bottom: .6rem;
			
	// 		.list {
	// 			display: flex;
	// 			align-items: center;

	// 			.left {
	// 				width: 5rem;
	// 				height: 5rem;
	// 				// background: #E6ECF2;
	// 				// border: 1px #9FBEED solid;
	// 				border-radius: .2rem;
	// 				flex-shrink: 0;
	// 				display: flex;
	// 				align-items: center;
	// 				justify-content: center;
	// 				margin-right: .55rem;

	// 				.img {
	// 					width: 100%;
	// 					height: 100%;
	// 				}
	// 			}

	// 			.right {
	// 				.name {
	// 					font-size: .7rem;
	// 					font-family: PingFang SC, PingFang SC;
	// 					font-weight: 500;
	// 					color: #333333;
	// 					line-height: .8rem;
	// 				}

	// 				.text {
	// 					font-size: .6rem;
	// 					font-family: PingFang SC, PingFang SC;
	// 					font-weight: 400;
	// 					color: #666666;
	// 					line-height: .7rem;
	// 					margin-top: .4rem;
	// 				}
	// 			}

	// 			.expire {
	// 				width: 2.75rem;
	// 				height: 2.75rem;
	// 				position: absolute;
	// 				top: .2rem;
	// 				right: .2rem;
	// 			}
	// 		}

	// 		.list-bottom {
	// 			border-top: 1px solid #DDDDDD;
	// 			padding-top: .6rem;
	// 			display: flex;
	// 			align-items: center;
	// 			justify-content: space-between;
	// 			margin-top: .6rem;

	// 			.text {
	// 				font-size: .6rem;
	// 				font-family: PingFang SC, PingFang SC;
	// 				font-weight: 400;
	// 				color: #666666;
	// 				line-height: .7rem;
	// 				flex: 1;

	// 				span {
	// 					color: #EA0029;
	// 					text-decoration: underline;
	// 				}
	// 			}

	// 			.btn {
	// 				width: 4rem;
	// 				height: 1.25rem;
	// 				font-size: .6rem;
	// 				font-family: PingFang SC, PingFang SC;
	// 				font-weight: 400;
	// 				color: #FFFFFF;
	// 				line-height: 1.25rem;
	// 				background: #0048BC;
	// 				border-radius: .2rem;
	// 				text-align: center;
	// 			}
	// 		}
	// 	}
	// }

	.van-popup {
		width: 100%;
    background: none;
    overflow: visible;
	}
}

// 中奖弹窗
.prize-dialog {
    display: flex;
    flex-direction: column;
    align-items: center;
    .dialog-center{

    }
    .dialog-center-10{
        width: 13.1rem;
        height: 27.25rem;
        background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/prize_big_bg.png) no-repeat;
        background-size: 100% 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 1.15rem;
        .congratulation{
            font-family: PingFang TC;
            font-weight: 500;
            font-size: 1.1rem;
            color: #FFE1B6;
            line-height: 1.1rem;
            margin-bottom: 0.6rem;
        }
        .grade{
            width: 6.2rem;
            height: 1.85rem;
            margin-bottom: 0.4rem;
        }
        .prize-logo{
            width: 100%;
            height: 2.65rem;
            margin-bottom: 0.75rem;
        }
        .name{
            width: 10.5rem;
            height: 1.45rem;
            margin-bottom: 0.7rem;
        }
        >div{
            div{
                span{
                    display: block;
                    font-family: PingFang TC;
                    font-weight: 500;
                    font-size: 0.55rem;
                    color: #FFE1B6;
                    line-height: 0.55rem;
                    margin-bottom: 0.3rem;
                }
                input{
                    width: 9.7rem;
                    height: 1.4rem;
                    border-radius: 0.4rem;
                    background: #FFFFFF;
                    border: 0.05rem solid #F5EC88;
                    margin-bottom: 0.4rem;
                    padding-left: 0.3rem;
                }
            }
        }
        .text{
            font-family: PingFang TC;
            font-weight: 500;
            font-size: 0.6rem;
            color: #FFE1B6;
            line-height: 0.8rem;
        }
        .tips{
            font-family: PingFang TC;
            font-weight: 400;
            font-size: 0.5rem;
            color: #DDDAD6;
            line-height: 0.5rem;
            padding-top: 0.75rem;
            margin-bottom: 0.75rem;
        }
        >button{
            width: 5.9rem;
            height: 1.5rem;
            background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/submit_btn_bg.png) no-repeat;
            background-size: 100% 100%;
        }
    }
    .dialog-center-detail{
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 13.1rem;
      height: 17.45rem;
      background: url(https://cdn.geement.com/sfiles/AnShiLiuHe/AnShiLiuHe_actH5_2025_06/prize_detail_bg.png) no-repeat;
      background-size: 100% 100%;
      padding-top: 5.6rem;
      >span{
        display: block;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 0.8rem;
        color: #FFFFFF;
        line-height: 1.15rem;
        margin-bottom: 0.7rem;
      }
      >div{
        width: 11.5rem;
        height: 9.15rem;
        background: #FFFFFF;
        border-radius: 0.4rem;
        display: flex;
        align-items: center;
        justify-content: center;
        >div{
          width: 10.7rem;
          height: 8.35rem;
          background: #F5F5F5;
          border-radius: 0.4rem;
          padding: 0.2rem 0;
          >div{
            display: flex;
            padding: 0 0.4rem;
            span{
              display: block;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 24rpx;
              color: #333333;
              line-height: 0.85rem;
              padding: 0.2rem 0;
            }
            .value{
              flex: 1;
              text-align: right;
            }
          }
        }
      }
    }
    .close {
        width: 1.4rem;
        height: 1.4rem;
        margin: 1.2rem 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/pictures/index.vue